import { createContext, useContext } from "react";

import { RydeUiUnit } from "@ryde/shared";

export interface IPageContext {
  entity: RydeUiUnit;
}

const PageContext = createContext<IPageContext>({
  entity: "unknown",
});

PageContext.displayName = "PageContext";
export const usePageContext = (): IPageContext => useContext(PageContext);

export { PageContext };
